import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { IngredientCreateFoodcostPricePage } from '../../ingredient-create/ingredient-create-foodcost-price/ingredient-create-foodcost-price';

@Component({
    selector: 'page-ingredient-view-others',
    templateUrl: 'ingredient-view-others.html',
})
export class IngredientViewOthersPage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {

    }


    editSalesInfo() {
        this.navCtrl.push(IngredientCreateFoodcostPricePage, {
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            ingredient_name: this.globals.nameLangSelectProduct(this.ingredient),
            ean: this.ingredient.ean,
            ingredient: this.ingredient,

        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-others/ingredient-view-others.ts